module.exports = __webpack_public_path__ + "img/da.b6b865fd.png";